import {HttpClient, HttpRequest, HttpResponse} from './type'

export class FetchHttpClientAdapter implements HttpClient {
  async request(data: HttpRequest): Promise<HttpResponse<any>> {
    const response = await fetch(data.url, {
      method: data.method,
      headers: data.headers,
      body: data.body,
    })
    return {
      statusCode: response.status,
      body: await response.json(),
    }
  }

  // async get<T>(url: string): Promise<HttpResponse<T>> {
  //   let fetchResponse = null
  //   try {
  //     const response = await fetch(url)
  //     fetchResponse = await response.json()
  //   } catch (error) {
  //     const _error = error as Error
  //     throw new Error(_error?.message)
  //   }
  //   return {
  //     statusCode: fetchResponse.status,
  //     body: fetchResponse,
  //   }
  // }
  // async post<T>(url: string, body: any): Promise<HttpResponse<T>> {
  //   let fetchResponse
  //   try {
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       body:body,
  //     })
  //     fetchResponse = await response.json()
  //   } catch (error) {
  //     const _error = error as Error
  //     throw new Error(_error?.message)
  //   }
  //   return {
  //     statusCode: fetchResponse.status,
  //     body: fetchResponse,
  //   }
  // }
}
